import { render, staticRenderFns } from "./TableBrands.vue?vue&type=template&id=c2935ce6"
import script from "./TableBrands.vue?vue&type=script&lang=js"
export * from "./TableBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports